/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareMusicDouble: {
  name: 'square-music-double';
  data: string;
} = {
  name: 'square-music-double',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h1V4Zm0 3H5v12h12v-1H8a2 2 0 0 1-2-2V7Zm12 9H8V4h12v12h-2Zm.316-9.051a1 1 0 1 0-.632-1.898l-2.317.772A2 2 0 0 0 14 7.721v1.45A3 3 0 1 0 16 12V7.72l2.316-.772ZM14 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z" fill="currentColor"/></svg>`,
};
